;(function ( $ ) {

    /**
     *  numberInput
     *  adds buttons to increment, decrement a number input
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'numberInput';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.min = null;
            this.max = null;
            this.initialWidth = $(this.element).width();
            this.initialHeight = $(this.element).height();
            if ($(this.element).attr('min')) {
                this.min = $(this.element).attr('min');
            }
            if ($(this.element).attr('max')) {
                this.max = $(this.element).attr('max');
            }
            this.$fieldset = $(this.element).parents('fieldset');
            // $(this.element).attr('type', 'text');
            if (!this.$fieldset.find('.number-input-wrapper').length) {
                $(this.element).wrap('<div class="number-input-wrapper" />');
                this.$wrapper = this.$fieldset.find('.number-input-wrapper');
                this.$wrapper.prepend('<a href="#" class="number-decrement border-color-event color-event bg-color-event-hover">-</div>');
                this.$wrapper.append('<a href="#" class="number-increment border-color-event color-event bg-color-event-hover">+</div>');
                this.$decrement = this.$wrapper.find('.number-decrement');
                this.$increment = this.$wrapper.find('.number-increment');
            }
            $(this.element).width(this.initialWidth - 160);

            this.registerEvents();
        },
        registerEvents: function() {
            var _this = this;
            var val;
            this.$increment.on('click', function(e) {
                e.preventDefault();
                val = parseInt($(_this.element).val());
                val++;
                if (_this.max === null || (_this.max !== null && val <= _this.max)) {
                    $(_this.element).val(val);
                }
            });
            this.$decrement.on('click', function(e) {
                e.preventDefault();
                val = parseInt($(_this.element).val());
                val--;
                if (_this.min === null || (_this.min !== null && val >= _this.min)) {
                    $(_this.element).val(val);
                }
            });
            $(this.element).on('change', function(e) {
                var val = $(_this.element).val();
                if ( isNaN( parseInt( val ) ) ) {
                    val = 1;
                }
                val = parseInt(val);
                if (_this.max !== null && val > _this.max) {
                    val = _this.max;
                }
                if (_this.min !== null && val < _this.min) {
                    val = _this.min;
                }
                $(_this.element).val(val);
            });


        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
